$(function(){
    function generateUniqueId(prefix) {
        return prefix + '_' + Math.random().toString(36).substr(2, 9);
    }

    // Assign unique IDs to each list and button
    $('.department-tree-div').each(function (index) {
        var uniqueListId = generateUniqueId('location_department');
        var uniqueButtonId = generateUniqueId('show_department');

        $(this).find('ul.location_department_main').attr('id', uniqueListId);
        $(this).find('a.show_departments_rental').attr('id', uniqueButtonId);

        // Assign unique IDs to list items
        $(this).find('ul.location_department_main li').each(function (liIndex) {
            var uniqueLiId = uniqueListId + '_li_' + liIndex;
            $(this).attr('id', uniqueLiId);
        });

        // Attach click event handler to the button
        $('#' + uniqueButtonId).click(function () {
            // Toggle the hidden class on list items and carlist-hidden class on the <ul>
            $('#' + uniqueListId + ' li.carlist-hidden').toggleClass('hidden');
            $('#' + uniqueListId).toggleClass('carlist-hidden');

            // Check if the <ul> element has the carlist-hidden class to determine button text and icon
            var isHidden = $('#' + uniqueListId).hasClass('carlist-hidden');
            var text = isHidden ? "<span class='underline'>"+ window.i18next.t('layout.labels.show_less') +"</span>" : "<span class='underline'>"+ window.i18next.t('layout.labels.show_more') +"</span>";
            var iconClass = isHidden ? "fa-chevron-up" : "fa-chevron-down";

            // Update button text and icon
            $('#' + uniqueButtonId).html(text + '<i class="fa-solid ' + iconClass + ' pl-2"></i>');
        });
    });
});